import { CellContext, createColumnHelper, RowData } from '@tanstack/react-table';

import { Translate } from 'components/Translate/Translate';

import { HeaderCell } from '../cells/HeaderCell';
import { ColumnTypesInternal } from '../Types';

export const indexColumn = <TData extends RowData>(columnHelper: ReturnType<typeof createColumnHelper<TData>>) =>
  columnHelper.display({
    id: ColumnTypesInternal.procuros_index,
    header: (props) => (
      <HeaderCell
        {...props}
        tooltip={<Translate i18nKey={`webedi:indexColumn.${props.table.options.meta?.dataPrefix}.description`} />}
        mode={props.table.options.meta?.mode}
      >
        <Translate i18nKey={`webedi:indexColumn.${props.table.options.meta?.dataPrefix}.label`} />
      </HeaderCell>
    ),
    meta: {
      type: ColumnTypesInternal.procuros_index,
      readOnly: true,
    },
    cell: IndexCell,
  });

const IndexCell = <TData, TValue>(props: CellContext<TData, TValue>) => {
  return (
    <div className="flex size-full items-center justify-end px-3 text-end">
      {new Intl.NumberFormat(navigator.language, { minimumIntegerDigits: 3 }).format(props.row.index + 1)}
    </div>
  );
};

/**
 * i18n
 *
 * t("webedi:indexColumn.transport_units.description")
 * t("webedi:indexColumn.transport_units.label")
 *
 * t("webedi:indexColumn.locations.description")
 * t("webedi:indexColumn.locations.label")
 */
